import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { screenXsMax } from '@spotify-internal/encore-web';

// EntityAttributeRow

const AttributeRow = styled.div`
  display: flex;

  @media (max-width: ${screenXsMax}) {
    ${'' /* hides elements without priority */} > :not([data-priority]) {
      display: none;
    }

    ${'' /* only displays first element with priority */} > [data-priority] ~ [data-priority] {
      display: none;
    }
  }
`;

export default function EntityAttributeRow({ children, className = undefined, ...otherProps }) {
  return (
    <AttributeRow className={className} {...otherProps}>
      {children}
    </AttributeRow>
  );
}

EntityAttributeRow.propTypes = {
  /** Attributes / stats to be displayed under the title. Can use EntityAttribute. */
  children: PropTypes.node,
  className: PropTypes.string,
};
